var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24"}},[_c('path',{staticClass:"fill-current",attrs:{"d":_vm.path}})])}
var staticRenderFns = []

export { render, staticRenderFns }